import { apiClient } from 'axios-client';
import { useCurrentBilikPerson } from 'hooks/use-current-bilik-person/use-current-bilik-person';
import React, { FunctionComponent, useState } from 'react';
import { Button, Icon } from 'semantic-ui-react';
import { ToastError, ToastSuccess, ToastWarn } from 'utils/toast';

type CheckReviewButtonProps = {
  reviewId: number;
  onCompleted?: () => void;
};

const CheckReviewButton: FunctionComponent<CheckReviewButtonProps> = ({
  reviewId,
  onCompleted,
}) => {
  const { currentBilikPerson } = useCurrentBilikPerson();
  const [isSubmitting, setSubmitting] = useState(false);

  return (
    <Button
      disabled={isSubmitting}
      loading={isSubmitting}
      primary
      onClick={async (event): Promise<void> => {
        event.preventDefault();
        setSubmitting(true);

        try {
          const response = await apiClient.post(`/form/review-pro/check`, {
            proReviewId: reviewId,
            checkerId: currentBilikPerson?.id,
          });

          response.data.success
            ? ToastSuccess('Succès', 'Réponse envoyée')
            : ToastWarn('Attention', response.data.message);
        } catch (error) {
          setSubmitting(false);
          ToastError('Erreur', 'Erreur lors de la demande de vérification');
          throw error;
        }

        if (onCompleted) {
          onCompleted();
        }
      }}
    >
      <Icon name="envelope" />
      Envoyer
    </Button>
  );
};

export default CheckReviewButton;
